<template>
  <n-full-screen
    overlay
    class="book-ride"
  >
    <n-dialog
      name="book-ride"
    />

    <n-scrollable>
      <web-header />

      <div class="book-ride-wrapper">
        <router-view />
      </div>
    </n-scrollable>
  </n-full-screen>
</template>

<script>
import { mapMutations } from 'vuex';
import { browserLang } from '@/i18n';
import { isBrowser } from '@/device';
import WebHeader from '@/screens/landing/webHeader';

export default {
  name: 'LandingBookRideIndex',
  components: {
    WebHeader,
  },
  beforeRouteEnter(to, from, next) {
    if (!isBrowser()) {
      return next('/');
    }

    next((vm) => {
      vm.selectLanguage({
        lang: browserLang,
        withDefaults: true,
      });
    });
  },
  methods: {
    ...mapMutations('user', {
      selectLanguage: 'SELECT_LANGUAGE',
    }),
  },
};
</script>

<style lang="scss" scoped>
.book-ride {
  min-width: 350px;
  display: flex;
}

.book-ride-wrapper {
  max-width: 650px;
  margin: 0 auto;
  width: 100%;
}
</style>